import { Box, CircularProgress, Typography } from '@mui/material';
import { useBrandState } from 'src/contexts/BrandContext';
import Logo from './Logo';
import { useTranslation } from 'react-i18next';

export default function BrandGate({ children }) {
  const { brand, loading, disabled } = useBrandState();
  const { t } = useTranslation();

  // Custom domains do not have a slug in the hostname, so we cannot know
  // whether they are branded until /brand/config resolves by host. Keep every
  // route (including login and registration) behind the loading state to avoid
  // briefly mounting public pages with Careit defaults and leaving translated
  // copy stuck on those defaults.
  if (loading) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (disabled) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          px: 3,
          gap: 2,
        }}
      >
        <Logo sx={{ height: 48, mb: 1 }} />
        <Typography variant="h4">{t('brand-gate.title')}</Typography>
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ maxWidth: 420 }}
        >
          {brand?.displayName
            ? t('brand-gate.named-body', { name: brand.displayName })
            : t('brand-gate.body')}
        </Typography>
      </Box>
    );
  }

  return children;
}
